import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { Form } from '../../components';
import EditListingFaqSection from './EditListingFaqSection';

const items = [
  {
    question: 'How long does delivery take?',
    answer:
      '<p>Most projects are delivered within two weeks. I confirm the exact schedule after our kickoff call.</p>',
  },
  {
    question: 'How many revision rounds are included?',
    answer:
      '<p>Two rounds of revisions are included. Extra rounds are billed at my hourly rate, and I always tell you before I start them.</p>',
  },
  {
    question: 'What do you need from me to get started?',
    answer:
      '<p>Access to your analytics and website CMS, your brand guidelines and a short brief about your goals.</p>',
  },
  {
    question: 'Can you also write the content?',
    answer:
      '<p>Yes. Content production isn’t included in this service, but I’m happy to quote it separately.</p>',
  },
  {
    question: 'Do you work with companies outside Finland?',
    answer:
      '<p>Yes. I work in English and Finnish with clients across Europe, and all meetings are online.</p>',
  },
];

const FaqForm = props => (
  <FinalForm
    {...props}
    onSubmit={() => null}
    mutators={{ ...arrayMutators }}
    render={({ handleSubmit }) => (
      <Form onSubmit={handleSubmit} style={{ maxWidth: 880 }}>
        <EditListingFaqSection />
      </Form>
    )}
  />
);

export const Empty = {
  component: FaqForm,
  props: { initialValues: { faq: [], faqDraft: null } },
  group: 'service listing',
};

export const NewQuestionIncomplete = {
  component: FaqForm,
  props: {
    initialValues: {
      faq: [items[0]],
      faqDraft: { question: 'How many revision rounds are included?', answer: '', __index: null },
    },
  },
  group: 'service listing',
};

export const Saved = {
  component: FaqForm,
  props: { initialValues: { faq: items.slice(0, 2), faqDraft: null } },
  group: 'service listing',
};

export const EditingSaved = {
  component: FaqForm,
  props: {
    initialValues: {
      faq: items.slice(0, 2),
      faqDraft: { ...items[0], __index: 0 },
    },
  },
  group: 'service listing',
};

export const AllFive = {
  component: FaqForm,
  props: { initialValues: { faq: items, faqDraft: null } },
  group: 'service listing',
};
